export default "__VITE_ASSET__htjHhhtb__"